<template>
    <div id="mainprojects">
        <Nav currentpath="/projects">
            <h1>Projects</h1>

            <div class="project" v-for="a in projects" :key="a.title">
                <h2>{{a.title}}</h2>
                <p>{{a.text}}</p>
                <div class="links">
                    <a class="fakeicon" :href="e.link" v-for="e in a.actions" :key="e.link">{{e.name}}</a>
                </div>
            </div>
        </Nav>
    </div>
</template>

<script>
import Nav from "../../components/Nav.vue"

export default {
    name: 'Projects',
    components: {Nav},
    data() {
        return {
            projects: [
                {
                    "title": "Combinator-based Anytime Tree Search Algorithms framework",
                    "text": "Implements several generic tree search algorithms for combinatorial optimization into a generic C++ framework",
                    "actions": [
                        {"name": "source", "link": "https://gitlab.com/librallu/cats-framework"}
                    ],
                },{
                    "title": "Microfluidic Chip designer (collaboration with Netri.fr)",
                    "text": "Tool to design Microfluidic chips semi-automatically (to be published soon)",
                    "actions": [
                        {"name": "link", "link": "https://chipdesigner.netri.fr"},
                    ],
                },{
                    "title": "Triangle Width application",
                    "text": "Given a binary matrix. Find the biggest white upper-right triangle by permuting rows and columns.",
                    "actions": [
                        {"name": "Demo", "link": "http://librallu.gitlab.io/hypergraph-viz/"},
                        {"name": "Source", "link": "https://gitlab.com/librallu/hypergraph-viz"},
                    ],
                },{
                    "title": "Packing Viz application",
                    "text": "Visualizes solutions for many guillotine bin packing problems",
                    "actions": [
                        {"name": "Demo", "link": "https://librallu.gitlab.io/packing-viz/"},
                        {"name": "Source", "link": "https://gitlab.com/librallu/packing-viz"},
                    ],
                },
                // {
                //     "title": "Tool Switching application",
                //     "text": "Given a set of tools and jobs and a capacity. Find a sequence that minimizes the needed changes of tools.",
                //     "actions": [
                //         {"name": "Demo", "link": "http://librallu.gitlab.io/tool-switching-viz/"},
                //         {"name": "Source", "link": "https://gitlab.com/librallu/tool-switching-viz"},
                //     ],
                // }
                
            ]
        }
    },
}
</script>

<style lang="scss">
    h1 {
        margin-bottom: 50px;
    }

    #mainprojects {
        padding: 10px;

        .project {
            margin-bottom: 40px;

            p,h2 {
                margin: 5px;
            }
        }
    }
</style>
